export const formatMinutesSeconds = (ms: number): string => {
  const minutes = Math.floor(ms / 60000);
  const secs = Math.floor((ms % 60000) / 1000);
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};